/* hfs page helpers, loaded once (defer) by every hfs section; guarded against double boot.
   - [data-hfs-scroll] / a[href^="#hfs-"]: smooth scroll, offset by the sticky countdown bar.
   - [data-hfs-countdown="week|midnight|minutes:N"] with children [data-d] [data-h] [data-m] [data-s]
     (any subset). "week" = next Sunday 23:59:59 local, "midnight" = tonight 23:59:59,
     "minutes:N" = rolling N-minute window kept per browser in localStorage.
   - [data-hfs-month]: current month name. [data-hfs-date]: "September 16". [data-hfs-weekday]: "Tuesday".
   - window.HFS.scrollTo(selector) for sections that need it. */
(function () {
  if (window.HFS) return;
  var HFS = window.HFS = {};
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  function barOffset() {
    var bar = document.querySelector('[data-hfs-bar]');
    return bar ? bar.getBoundingClientRect().height + 12 : 12;
  }
  HFS.scrollTo = function (sel) {
    var el = typeof sel === 'string' ? document.querySelector(sel) : sel;
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - barOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-hfs-scroll], a[href^="#hfs-"]');
    if (!a) return;
    var target = a.getAttribute('data-hfs-scroll') || a.getAttribute('href') || '#hfs-buy';
    if (target.charAt(0) !== '#') target = '#hfs-buy';
    if (!document.querySelector(target)) return;
    e.preventDefault();
    HFS.scrollTo(target);
  });

  function deadline(mode) {
    var now = new Date();
    if (mode === 'midnight') { var m = new Date(now); m.setHours(23, 59, 59, 999); return m.getTime(); }
    if (mode && mode.indexOf('minutes:') === 0) {
      var mins = parseInt(mode.split(':')[1], 10) || 30;
      var key = 'hfs_cd_' + mins, end = 0;
      try { end = parseInt(localStorage.getItem(key), 10) || 0; } catch (err) {}
      if (end < now.getTime()) {
        end = now.getTime() + mins * 60000;
        try { localStorage.setItem(key, String(end)); } catch (err) {}
      }
      return end;
    }
    var w = new Date(now); var add = (7 - w.getDay()) % 7; w.setDate(w.getDate() + add); w.setHours(23, 59, 59, 999);
    return w.getTime();
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tick() {
    document.querySelectorAll('[data-hfs-countdown]').forEach(function (el) {
      var mode = el.getAttribute('data-hfs-countdown');
      if (!el.__end || el.__end < Date.now()) el.__end = deadline(mode);
      var left = Math.max(0, el.__end - Date.now());
      var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
      var dEl = el.querySelector('[data-d]'), hEl = el.querySelector('[data-h]');
      if (!dEl && hEl) h += d * 24;
      [['[data-d]', d], ['[data-h]', h], ['[data-m]', m], ['[data-s]', s]].forEach(function (p) {
        el.querySelectorAll(p[0]).forEach(function (n) { n.textContent = n.hasAttribute('data-pad') ? pad(p[1]) : String(p[1]); });
      });
    });
  }
  function dates() {
    var now = new Date();
    document.querySelectorAll('[data-hfs-month]').forEach(function (n) { n.textContent = MONTHS[now.getMonth()]; });
    document.querySelectorAll('[data-hfs-date]').forEach(function (n) { n.textContent = MONTHS[now.getMonth()] + ' ' + now.getDate(); });
    document.querySelectorAll('[data-hfs-weekday]').forEach(function (n) { n.textContent = DAYS[now.getDay()]; });
  }
  function boot() { dates(); tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
